import { TenantId } from '@amzn/ring-rse-scheduling-service-typescript-client';
import { client } from 'api/client';

import { getResponseData } from 'utils/url';

export async function getTenantConfig(tenantId: TenantId) {
    return (await getResponseData(client.getTenantConfigV1(tenantId))).data;
}
